<div class="content">
  <h2>Access denied<br>
    You don't have enough permission
  </h2>
  <a href="{{subscriptionLink}}">Change Subscription</a>
</div>
